"use client";

import dynamic from "next/dynamic";
import { Loader } from "@/components/common/loader";
import type { FilterMultiLayoutType } from "@/features/filters/components/filter-multi/filter-multi-form";
import type { FilterMultiType } from "../../types/filter-multi.type";

const FilterMultiForm = dynamic(
  () => import("./filter-multi-form").then((mod) => mod.FilterMultiForm),
  {
    loading: () => <Loader />,
  },
);

type FilterMultiFormWrapperProps = {
  filter: FilterMultiType;
  paramName: string;
  collapsible: boolean | number | string;
  type?: "checkbox" | "button";
  form: any;
  listWrapperClass?: string;
  multiple: boolean;
  stretch?: boolean;
  layout?: FilterMultiLayoutType;
  collapsibleButtonLabel?: string;
};

export function FilterMultiFormWrapper(props: FilterMultiFormWrapperProps) {
  return <FilterMultiForm {...props} />;
}
